// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('budget', {
        url: '/budget',
        parent: 'main',
        abstract: true,
        templateUrl: "main/budget/budget.tpl.html",
        controller: "MainBudgetController as vm"
    });
}

// @ngInject
function MainBudgetController() {
    var vm = this;
}

angular
    .module('main.budget', ['budgets.api', 'budget.budgets'])
    .config(stateConfig)
    .controller('MainBudgetController', MainBudgetController);
